// extracted by mini-css-extract-plugin
module.exports = {"bodyBg":"#cdcdcd","slideBarWidth":"280px","titleColor":"blue"};